import React from 'react';
import { Col, Row, Spin, Typography } from 'antd';
import { useLoader } from '../../context/loaderContext';
import "../layout/layout.scss";

const { Text } = Typography;

const Loading = () => {
    const { loading, loadingText } = useLoader();

    if (!loading) return null;

    return (
        // <Flex align='center' style={{ width: "100%" }} justify='center'>
        //     <Space direction='vertical' align='center'>
        //         <Spin indicator={<LoadingOutlined spin />} size="large" />
        //         <Text>{loadingText ? loadingText : "Loading..."}</Text>
        //     </Space>
        // </Flex>

        <Row className="fullscreen-loader">
            <div className="loader-overlay"></div>
            <Col className="loader-content" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                <Spin size="large"/>
                <Text style={{ marginTop: 20 }}>{loadingText ? loadingText : "Loading..."}</Text>
            </Col>
        </Row>
    );
}
export default Loading;